import React, {useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Button, TextField, Stack, CircularProgress } from '@mui/material';

import { getPlayQuizAndOpen } from '../../../actions/playQuiz';
import Language from '../../Language/Language';
import { COLOR_TEXT_PRIMARY } from '../../../constants/styleValues';


const Join = () => {
    //Variables
    const dispatch = useDispatch();
    const selectedLanguage = useSelector((state) => state.Language); //get the selected language from the store. set within navigation component

    //every text is stored within this constant
    //translation are done here - just enter a different language
    const componentContent = {
        language_DE:{
            validationMessageMissingPIN:'Bitte PIN eingeben',
            buttonLabelSubmit:'Beitreten',
            inputLabelPIN:'Bitte PIN eingeben',
            backButton:'Zurück'
        },
        language_EN:{
            validationMessageMissingPIN:'Please enter a PIN',
            buttonLabelSubmit:'Join',
            inputLabelPIN:'Please enter a PIN',
            backButton:'Back'
        },
        language_FR:{
            validationMessageMissingPIN:'Veuillez entrer un code PIN',
            buttonLabelSubmit:'Rejoindre',
            inputLabelPIN:'Veuillez entrer un code PIN',
            backButton:'Précédent'
        }
    }

    //++++++++++++++++STATE SETTINGS++++++++++++++++++
    const [quizid, setPin] = useState(0);
    const [showValidation, setShowValidation] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    //+++++++++++++++++FUCNTIONS++++++++++++++++++++
    //handle the PIN Input
    const handleChangePinInput = (pinInput) => {
        setPin(pinInput)
        setShowValidation(false)
    }
    //handle the submit event and check if the PIN is correct
    const handleSubmit = async (e) => {
        e.preventDefault();
        if(!quizid){
            setShowValidation(true);
            return;
        }
        setIsSubmitting(true);
        await dispatch(getPlayQuizAndOpen(quizid));
        setIsSubmitting(false);
    }

    return(
        <Grid container justifyContent="center" alignItems="center" textAlign="center" sx={{flex: 1, px: {xs: 2, sm: 3}}}>
            <Grid container maxWidth="lg" justifyContent="center" alignItems="center">
            <Language/>
                <Stack spacing={2}>
                    <form autoComplete='off' noValidate onSubmit={handleSubmit}>
                        <TextField
                            placeholder={componentContent[selectedLanguage].inputLabelPIN}
                            variant="outlined"
                            autoFocus
                            disabled={isSubmitting}
                            sx={{backgroundColor: 'rgba(255,255,255,0.08)', borderRadius: '8px', input: { color: COLOR_TEXT_PRIMARY }}}
                            onChange={(e) => handleChangePinInput(e.target.value)}
                        />
                        {showValidation ?
                            <div role="alert" style={{color: '#FF5C5C', marginTop: '8px'}}>{componentContent[selectedLanguage].validationMessageMissingPIN}</div>
                        : null}
                    </form>
                    <Button
                        variant="contained"
                        size="large"
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                        startIcon={isSubmitting ? <CircularProgress size={18} color="inherit" /> : null}
                    >
                        {componentContent[selectedLanguage].buttonLabelSubmit}
                    </Button>
                    <Button variant='text' href='/'>{componentContent[selectedLanguage].backButton}</Button>
                </Stack>
            </Grid>
        </Grid>
    )

}

export default Join